//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
  IconColors,
} from '@hub/design-system-base'
import { default as ChevronLeftMediumSVG } from './assets/medium/chevron-left.inline.svg'

interface ChevronLeftMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  ariaLabel?: string
  color?: IconColors
}

export const ChevronLeftMediumIcon: React.FC<
  React.PropsWithChildren<ChevronLeftMediumIconProps>
> = forwardRef<ChevronLeftMediumIconProps, typeof ChakraIcon>(
  ({ boxSize = 'size-icon-sm', sx, ariaLabel, color }, ref) => (
    <ChakraIcon
      ref={ref}
      boxSize={boxSize}
      aria-label={ariaLabel}
      as={ChevronLeftMediumSVG}
      sx={sx}
      color={color}
    />
  )
)
